import React from "react";
import "./Input.scss";
interface InputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  error?: string;
}
const Input: React.FC<InputProps> = ({
  label,
  value,
  onChange,
  required,
  error,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };
  return (
    <div className='wr-input'>
      <div className='wr-input-lable'>
        {label}
        {required && <span className='req-ic'>*</span>}
      </div>
      <div className={`wr-input-wrapper`}>
        <input
          className='wr-input-cont'
          value={value}
          onChange={handleChange}
        />
      </div>
      {error !== "" && <div className='wr-input-error'>{error}</div>}
    </div>
  );
};
export default Input;
